import React from 'react';
import Heading from '../../components/heading/Heading';
import AllFeatures from './components/AllFeatures';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Integrations from './components/Integrations';
import Pricing from './components/Pricing';
import VideoComponent from './components/VideoComponent';

const Home = (): React.JSX.Element => {
  return (
    <>
      <Heading />
      <main id="main-content" role="main" tabIndex={-1}>
        <Hero />
        <section id="overview" className="anchor-section">
          <VideoComponent />
        </section>
        <section id="features" className="anchor-section">
          <AllFeatures />
        </section>
        <section id="integrations" className="anchor-section">
          <Integrations />
        </section>
        <section id="pricing" className="anchor-section">
          <Pricing />
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Home;
